import SelectClients from '../components/Selects/SelectClients';
import SelectStatuses from '../components/Selects/SelectStatuses';
import SelectDealPaymentStatuses from '../components/Selects/selectDealPaymentStatuses';
import Datepicker from '../components/Inputs/Datepicker/Datepicker';
import SelectPaymentTypes from '../components/Selects/SelectPaymentTypes';
import Select from '../components/Select/Select';
import SelectManager from '../components/Selects/SelectManager';
import SelectContainers from '../components/Selects/SelectContainers';
import SelectSources from '../components/Selects/SelectSources';
import SelectDealStatuses from '../components/Selects/SelectDealStatuses';
import SelectLeadDealStatus from '../components/Selects/SelectLeadDealStatus';
import SelectComplectations from '../components/Selects/SelectComplectations';
import SelectFacet from '../components/Selects/SelectFacet';
import SelectStockCar from '../components/Selects/SelectStockCar';
import SelectCity from '../components/Selects/SelectCity';
import SelectMarks from '../components/Selects/SelectMarks';
import SelectModels from '../components/Selects/SelectModels';

export const clientOptions = [
  { name: 'fio', label: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°', placeholder: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°' },
  { name: 'iin', label: 'ÐÐÐ', placeholder: 'ÐÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°' },
  {
    name: 'vip',
    component: Select,
    label: 'VIP',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ',
    options: [
      { value: true, label: 'ÐÐ°' },
      { value: false, label: 'ÐÐµÑ' },
    ],
  },
  { name: 'company', label: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ', placeholder: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ' },
  { name: 'role', label: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ', placeholder: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ' },
  { name: 'phone', label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½', placeholder: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½' },
  { name: 'email', label: 'E-mail', placeholder: 'E-mail' },
  {
    name: 'broker',
    label: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº',
    component: Select,
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ',
    options: [
      { value: true, label: 'ÐÐ°' },
      { value: false, label: 'ÐÐµÑ' },
    ],
  },
];

export const servicesOptions = [
  { name: 'id', label: 'ÐÐ', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ ÐÐ' },
  { name: 'title', label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ' },
  { name: 'price', label: 'Ð¦ÐµÐ½Ð°', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ ÑÐµÐ½Ñ' },
];

export const leadOptions = [
  { fio_label: 'Ð¤ÐÐ Ð»Ð¸Ð´Ð°', fio_placeholder: 'Ð¤ÐÐ Ð»Ð¸Ð´Ð°' },
  { iin_label: 'ÐÐÐ', iin_placeholder: 'ÐÐÐ Ð»Ð¸Ð´Ð°' },
  { vip_label: 'VIP', vip_placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ' },
  { company_label: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ', company_placeholder: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ' },
  { role_label: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ', role_placeholder: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ' },
  { phone_label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½', phone_placeholder: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½' },
  { email_label: 'E-mail', email_placeholder: 'E-mail' },
  { broker_label: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº', broker_placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ' },
];

export const dealOptions = [
  { fio_label: 'Ð¤ÐÐ Ð»Ð¸Ð´Ð°', fio_placeholder: 'Ð¤ÐÐ Ð»Ð¸Ð´Ð°' },
  { iin_label: 'ÐÐÐ', iin_placeholder: 'ÐÐÐ Ð»Ð¸Ð´Ð°' },
  { vip_label: 'VIP', vip_placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ' },
  { company_label: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ', company_placeholder: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ' },
  { role_label: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ', role_placeholder: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ' },
  { phone_label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½', phone_placeholder: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½' },
  { email_label: 'E-mail', email_placeholder: 'E-mail' },
  { broker_label: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº', broker_placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ' },
];

export const carsOptions = [
  { name: 'containerId', component: SelectContainers },
  { name: 'complectationId', component: SelectComplectations, params: () => carsOptions[0]?.value?.value },
  { name: 'markId', component: SelectMarks },
  {
    name: 'modelId', component: SelectModels,
    dependency: 'markId',
    dependencyAccessor: (obj) => obj?.value,
  },
  { name: 'stock', component: SelectStockCar, label: 'Ð Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸' },
  { name: 'cityId', component: SelectCity, label: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
];

// Ð¢Ðµ Ð¶Ðµ ÑÐ¸Ð»ÑÑÑÑ, ÑÑÐ¾ Ð¸ carsOptions, Ð½Ð¾ Ð±ÐµÐ· "Ð Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸" â ÑÑÑÐ°Ð½Ð¸ÑÐ° ÑÑÐ¾ÐºÐ¾Ð²ÑÑ Ð°Ð²ÑÐ¾
// Ð¸ ÑÐ°Ðº Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾Ðº (forApp=true+stock=true ÑÐ¾ÑÑÐ¸ÑÑÐµÑÑÑ Ð½Ð°
// ÑÑÐ¾Ð²Ð½Ðµ Ð·Ð°Ð¿ÑÐ¾ÑÐ°), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð´ÑÐ±Ð»Ð¸ÑÑÑÑÐ¸Ð¹ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ ÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ±Ð¸Ð²Ð°Ð» Ð±Ñ Ñ ÑÐ¾Ð»ÐºÑ
// Ð¤Ð¸Ð»ÑÑÑÑ ÑÑÐ¾ÐºÐ°. ÐÑÐµ Ð²Ð°ÑÐ¸Ð°Ð½ÑÑ Ð¸ ÑÑÑÑÑÐ¸ÐºÐ¸ Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð¾Ð´Ð½Ð¸Ð¼ Ð¾ÑÐ²ÐµÑÐ¾Ð¼ getStockFilters Ð¸
// ÐºÐ»Ð°Ð´ÑÑÑÑ Ð² Ð¿Ð¾Ð»Ðµ options ÐºÐ°Ð¶Ð´Ð¾Ð¹ Ð¾Ð¿ÑÐ¸Ð¸ (ÑÐ¼. StockCars.jsx) â Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð·Ð´ÐµÑÑ Ð½ÐµÑ Ð½Ð¸
// dependency Ð¼ÐµÐ¶Ð´Ñ Ð¼Ð°ÑÐºÐ°Ð¼Ð¸ Ð¸ Ð¼Ð¾Ð´ÐµÐ»ÑÐ¼Ð¸, Ð½Ð¸ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÑ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¾Ð²: Ð±ÑÐº ÑÐ¶Ðµ Ð²ÐµÑÐ½ÑÐ»
// ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾, ÑÑÐ¾ ÐµÑÑÑ Ð² ÑÐµÐºÑÑÐµÐ¹ Ð²ÑÐ±Ð¾ÑÐºÐµ. ÐÐ¾ÑÑÐ´Ð¾Ðº Ð¿Ð¾Ð»ÐµÐ¹ â ÐºÐ°Ðº Ð¿ÑÐ¾ÑÐ¸Ð»Ð¸ Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ.
export const stockCarsOptions = [
  { name: 'cityId', component: SelectFacet, label: 'ÐÐ¾ÑÐ¾Ð´', placeholder: 'ÐÑÐµ Ð³Ð¾ÑÐ¾Ð´Ð°' },
  { name: 'dcId', component: SelectFacet, label: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ', placeholder: 'ÐÑÐµ ÐÐ¦' },
  { name: 'markId', component: SelectFacet, label: 'ÐÐ°ÑÐºÐ°', placeholder: 'ÐÑÐµ Ð¼Ð°ÑÐºÐ¸' },
  { name: 'modelId', component: SelectFacet, label: 'ÐÐ¾Ð´ÐµÐ»Ñ', placeholder: 'ÐÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ð¸' },
  { name: 'complectationId', component: SelectFacet, label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ', placeholder: 'ÐÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸' },
  { name: 'color', component: SelectFacet, label: 'Ð¦Ð²ÐµÑ', placeholder: 'ÐÑÐµ ÑÐ²ÐµÑÐ°' },
  { name: 'wdId', component: SelectFacet, label: 'ÐÑÐ¸Ð²Ð¾Ð´', placeholder: 'ÐÑÐ±Ð¾Ð¹ Ð¿ÑÐ¸Ð²Ð¾Ð´' },
  { name: 'engineVolume', component: SelectFacet, label: 'ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ, ÑÐ¼Â³', placeholder: 'ÐÑÐ±Ð¾Ð¹ Ð¾Ð±ÑÑÐ¼' },
];

export const equipmentOptions = [
  { name: 'id', label: 'ÐÐ', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ ÐÐ' },
  { name: 'title', label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ' },
  { name: 'price', label: 'Ð¦ÐµÐ½Ð°', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ ÑÐµÐ½Ñ' },
  {
    name: 'typeId',
    component: Select,
    label: 'Ð¢Ð¸Ð¿',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    options: [
      { value: 1, label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑ' },
      { value: 2, label: 'Ð¨ÑÑÐºÐ°' },
    ],
  },
];

export const reportOptions = [
  { fio_label: 'ÐÐ°ÑÐ°', fio_placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ' },
  { iin_label: 'ÐÐÐ', iin_placeholder: 'ÐÐÐ Ð»Ð¸Ð´Ð°' },
  { vip_label: 'VIP', vip_placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ' },
  { company_label: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ', company_placeholder: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ' },
  { role_label: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ', role_placeholder: 'ÐÐ¾Ð»Ð¶Ð½Ð¾ÑÑÑ' },
  { phone_label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½', phone_placeholder: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½' },
  { email_label: 'E-mail', email_placeholder: 'E-mail' },
  { broker_label: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº', broker_placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ' },
];

// isClearable â ÑÑÐ¾Ð±Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÑÐ½Ð¸Ð¼Ð°Ð»Ð¾ÑÑ Ð¿ÑÑÐ¼Ð¾ Ð² ÑÐµÐ»ÐµÐºÑÐµ: Ð¸Ð½Ð°ÑÐµ Ð¾Ð´Ð¸Ð½
// ÑÐ¸Ð»ÑÑÑ Ð¸Ð· Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ñ ÑÐ±Ð¸ÑÐ°Ð»ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ±ÑÐ¾ÑÐ¾Ð¼ Ð²ÑÐµÑ.
export const leadsOptions = [
  { name: 'createdAt', component: Datepicker, label: 'ÐÐ°ÑÐ°', placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³', isClearable: true },
  { name: 'clientId', component: SelectClients, isClearable: true },
  {
    name: 'managerId',
    component: SelectManager,
    label: 'ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    isClearable: true,
  },
  { name: 'fio', label: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°', placeholder: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°' },
  {
    name: 'markAndModel',
    component: SelectContainers,
    label: 'ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    isClearable: true,
  },
  {
    name: 'sourceId',
    component: SelectSources,
    label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    isClearable: true,
  },
  { name: 'phone', label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½', placeholder: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½' },
  { name: 'email', label: 'E-mail', placeholder: 'E-mail' },
  // Ð­ÑÐ¾ ÑÑÐ°ÑÑÑ Ð»Ð¸Ð´Ð° (SelectStatuses ÑÑÐ½ÐµÑ getLeadStatuses), Ð° Ð¿Ð»ÐµÐ¹ÑÑÐ¾Ð»Ð´ÐµÑ Ð¾Ð±ÐµÑÐ°Ð» ÑÐ´ÐµÐ»ÐºÑ.
  {
    name: 'statusId',
    component: SelectStatuses,
    label: 'Ð¡ÑÐ°ÑÑÑ Ð»Ð¸Ð´Ð°',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÑÐ°ÑÑÑ Ð»Ð¸Ð´Ð°',
    isClearable: true,
  },
  // ÐÐ±Ð° ÑÐ¸Ð»ÑÑÑÐ° ÑÐ¼Ð¾ÑÑÑÑ Ð½Ð° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÑÑ ÑÐ´ÐµÐ»ÐºÑ Ð»Ð¸Ð´Ð° â ÑÑ Ð¶Ðµ, ÑÑÐ¾ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð° Ð² ÐºÐ¾Ð»Ð¾Ð½ÐºÐµ Â«Ð¡Ð´ÐµÐ»ÐºÐ°Â».
  {
    name: 'dealStatusId',
    component: SelectLeadDealStatus,
    label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    isClearable: true,
  },
  {
    // Ð¡ÑÑÐ¾ÐºÐ¸, Ð° Ð½Ðµ Ð±ÑÐ»ÐµÐ²Ñ: false Ð½Ðµ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐµÑÑÑÑÑÑ ÐºÐ°Ðº Â«Ð¿ÑÑÑÐ¾ÐµÂ» Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð² Ð°Ð´ÑÐµÑÐµ Ð¸ Ð² Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð².
    name: 'dealApproved',
    component: Select,
    label: 'ÐÐ´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ',
    isClearable: true,
    options: [
      { value: 'true', label: 'ÐÑÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ' },
      { value: 'false', label: 'ÐÐµÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ' },
    ],
  },
];

export const dealsOptions = [
  { name: 'createdAt', component: Datepicker, label: 'ÐÐ°ÑÐ°', placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³' },
  { name: 'clientId', component: SelectClients },
  { name: 'sum', label: 'Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°, KZT', placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ ÑÑÐ¼Ð¼Ñ ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°' },
  { name: 'statusPaymentId', component: SelectDealPaymentStatuses, placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸' },
  {
    name: 'statusId',
    component: SelectDealStatuses,
    label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
    defaultValue: { paymentTypeId: 0 },
  },
  { name: 'paymentType', component: SelectPaymentTypes, label: 'Ð¤Ð¾ÑÐ¼Ð° Ð¾Ð¿Ð»Ð°ÑÑ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¾ÑÐ¼Ñ Ð¾Ð¿Ð»Ð°ÑÑ' },
];
